import React, { useRef } from "react";
import { useLocalStore } from "mobx-react";
import { toJS } from "mobx";
import Classic from "./themes/Classic";
import Default from "./themes/default.json";
import Blue from "./themes/Blue";
import Gold from "./themes/Gold";
// const StoreContext = React.createContext();
export const Store = React.createContext();

const StoreProvider = ({ children }) => {
  const store = useLocalStore(() => ({
    theme: Default,
    selectNewTheme: "",
    cols: [],
    setTheme: (data) => {
      store.theme = data;
      store.selectTheme = data.id;
    },
    selectTheme: "Classic",
    calenderRuslt: [],
    setCalenderResult: (value) => {
      store.calenderRuslt = value;
    },
    preview: false,
    onPreview: () => {
      store.preview = !store.preview;
    },
    select: "",
    setSelect: (value) => {
      console.log("=========");
      console.log("select ", store.select);
      console.log("select now :", value);
      console.log("preview :", toJS(store.preview));
      if (store.preview) store.onPreview();
      console.log(toJS(store.select));
      if (value === store.select || !value) store.select = "";
      else store.select = value;

      console.log("select value :", toJS(store.select));
      console.log("is :", toJS(store.select) === value);
    },
    clearSelect: (id) => {
      if (store.select !== id) store.select = "";
      console.log("FROM CLEAR select value :", toJS(store.select));
    },
    setMainColor: (property, value) => {
      store.theme.main[property].backgroundColor = value;
    },
    setHeaderColor: (value) => {
      store.theme.header.backgroundColor = value;
    },
    setNoteBackground: (property, value) => {
      store.theme.note[property].backgroundColor = value;
    },
    setBoxAttribute(where, attr, value) {
      store.calenderRuslt[where.month].date[where.day][attr] = value;
    },
    getBoxAttribute(where, attr) {
      return store.calenderRuslt[where.month].date[where.day][attr];
    },
    cleanBoxAttribute(where) {
      store.calenderRuslt[where.month].date[where.day].color = undefined;
      store.calenderRuslt[where.month].date[where.day].content = undefined;
    },
    indexTemp: 0,

    isAdmin: () => store.user.level,
    selectEditor: "",
    scrollTop: 0,
    resizeTemplate: true,
  }));

  return <Store.Provider value={store}>{children}</Store.Provider>;
};
export default StoreProvider;
